import { render, staticRenderFns } from "./InvestorReportDialog.vue?vue&type=template&id=8eb5d300&"
import script from "./InvestorReportDialog.vue?vue&type=script&lang=js&"
export * from "./InvestorReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvestorReportDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
